const searchParams = new URLSearchParams(location.search) || {};
const botId = searchParams.get('bot_id') ?? '';
const channelId = searchParams.get('channel_id') ?? '';

const tokenKey = 'AUTHORIZATION';
const tokenLimit = 50;

// 获取tokenid
function getAuthorizationId () {
  return 'Authorization_' + botId + '_' + channelId;
}

// 设置token信息
export function setAuthorizationData (data: Record<string, any>) {
  const id = getAuthorizationId(); // 当前智能体登录态id
  const list = JSON.parse(localStorage.getItem(tokenKey) ?? '[]') || [];
  const dataIndex = list?.findIndex((item: Record<string, any>) => item.id === id);
  // 设置 更新 token 信息
  if (dataIndex > -1) {
    const item = { ...list[dataIndex] };
    list.splice(dataIndex, 1);
    list.push({
      ...item,
      ...data
    });
  } else {
    list.push({
      id,
      ...data
    });
  }
  // 处理token长度
  if (list?.length > tokenLimit) {
    list.splice(0, list?.length - tokenLimit);
  }
  localStorage.setItem(tokenKey, JSON.stringify(list));
}

// 获取token信息
export function getAuthorizationData () {
  const id = getAuthorizationId(); // 当前智能体登录态id
  const list = JSON.parse(localStorage.getItem(tokenKey) ?? '[]') || [];
  const dataIndex = list?.findIndex((item: Record<string, any>) => item.id === id);
  // 移动token信息到最后
  if (list?.length > 1 && dataIndex > -1 && dataIndex < list?.length - 1) {
    const filterList = list?.filter((item: Record<string, any>) => item.id !== id) || [];
    const newList = [...filterList, list[dataIndex]];
    localStorage.setItem(tokenKey, JSON.stringify(newList));
  }
  // 返回token信息
  if (dataIndex > -1) {
    return list[dataIndex];
  } else {
    return {};
  }
}

// 获取登录token
export function getToken () {
  const id = getAuthorizationId(); // 当前智能体登录态id
  const list = JSON.parse(localStorage.getItem(tokenKey) ?? '[]') || [];
  const token = list?.find((item: Record<string, any>) => item.id === id)?.token || '';
  return token;
};

// 获取登录邮箱
export function getEmail () {
  const id = getAuthorizationId(); // 当前智能体登录态id
  const list = JSON.parse(localStorage.getItem(tokenKey) ?? '[]') || [];
  const email = list?.find((item: Record<string, any>) => item.id === id)?.email || '';
  return email;
};

// 获取登录手机号
export function getPhone () {
  const id = getAuthorizationId(); // 当前智能体登录态id
  const list = JSON.parse(localStorage.getItem(tokenKey) ?? '[]') || [];
  const phone = list?.find((item: Record<string, any>) => item.id === id)?.phone || '';
  return phone;
};

// 多语言
const languageKey = 'LANGUAGE_KEY';
export function getLanguageKey () {
  return localStorage.getItem(languageKey);
}

export function setLanguageKey (str: string) {
  localStorage.setItem(languageKey, str);
}

// guid
const guidKey = 'GUID_CHAT';
export function getGuidKey () {
  return localStorage.getItem(guidKey);
}

export function setGuidKey (str: string) {
  localStorage.setItem(guidKey, str);
}
